import { render, staticRenderFns } from "./GiftBagSelector.vue?vue&type=template&id=364bde96&lang=pug&"
import script from "./GiftBagSelector.vue?vue&type=script&lang=ts&"
export * from "./GiftBagSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports